import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { BaseWooCommerceAddressDetails } from '../../../core/interfaces/woo-commerce/woo-commerce.interface';
import { NgClass } from '@angular/common';
import { openGoogleMapsLocation } from '../../utils/google-maps.util';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-address-select',
  imports: [NgClass],
  templateUrl: './address-select.component.html',
  styleUrl: './address-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressSelectComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressSelectComponent implements ControlValueAccessor {
  icon: InputSignal<string> = input<string>('icon-bag-outline');
  label: InputSignal<string> = input<string>('Pickup');
  addresses: InputSignal<BaseWooCommerceAddressDetails[]> =
    input.required<BaseWooCommerceAddressDetails[]>();

  // State
  selectedAddressIndex: WritableSignal<number> = signal<number>(-1);

  onAddressClick(addressIndex: number): void {
    this.selectedAddressIndex.set(addressIndex);
    this.onChange?.(this.addresses()[addressIndex]);
  }

  protected readonly openGoogleMapsLocation = openGoogleMapsLocation;

  // ControlValueAccessor functions
  private onChange?: (value: BaseWooCommerceAddressDetails) => void;
  onTouch?: () => void;

  registerOnChange(fn: (value: BaseWooCommerceAddressDetails) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(outsideValue: BaseWooCommerceAddressDetails): void {
    const selectedAddressIndex: number = this.addresses().findIndex(
      (address: BaseWooCommerceAddressDetails): boolean => {
        return JSON.stringify(address) === JSON.stringify(outsideValue);
      }
    );

    this.selectedAddressIndex.set(selectedAddressIndex);
  }
}
